module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-messagelist-message kiwi-messagelist-message--modern",
    class: [
      _vm.ml.filteredMessages[_vm.idx - 1] &&
      _vm.ml.filteredMessages[_vm.idx - 1].nick === _vm.message.nick &&
      _vm.message.time - _vm.ml.filteredMessages[_vm.idx - 1].time < 60000 &&
      _vm.ml.filteredMessages[_vm.idx - 1].type !== 'traffic' &&
      _vm.message.type !== 'traffic' ?
      'kiwi-messagelist-message-repeat' :
      '',
      'kiwi-messagelist-message-' + _vm.message.type,
      _vm.message.type_extra ?
      'kiwi-messagelist-message-' + _vm.message.type + '-' + _vm.message.type_extra :
      '',
      _vm.ml.isMessageHighlight(_vm.message) ?
      'kiwi-messagelist-message--highlight' :
      '',
      _vm.ml.isHoveringOverMessage(_vm.message) ?
      'kiwi-messagelist-message--hover' :
      '',
      _vm.ml.buffer.last_read && _vm.message.time > _vm.ml.buffer.last_read ?
      'kiwi-messagelist-message--unread' :
      '',
      _vm.message.nick.toLowerCase() === _vm.ml.ourNick.toLowerCase() ?
      'kiwi-messagelist-message--own' :
      '',
      _vm.ml.message_info_open === _vm.message ?
      'kiwi-messagelist-message--info-open' :
      '',
      _vm.ml.message_info_open && _vm.ml.message_info_open !== _vm.message ?
      'kiwi-messagelist-message--blur' :
      '' ],
    attrs: {
      "data-message": _vm.message
    },
    on: {
      "click": function($event) {
        _vm.ml.onMessageClick($event, _vm.message)
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-messagelist-modern-left"
  }, [(_vm.isMessage(_vm.message)) ? _c('div', {
    staticClass: "kiwi-messagelist-modern-avatar",
    style: ({
      'background-color': _vm.nickColour(_vm.message.nick)
    }),
    attrs: {
      "data-nick": _vm.message.nick
    }
  }, [_vm._v("\n            " + _vm._s(_vm.message.nick[0]) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-messagelist-modern-right"
  }, [_c('div', {
    staticClass: "kiwi-messagelist-nick",
    style: (_vm.ml.nickStyle(_vm.message.nick)),
    attrs: {
      "data-nick": _vm.message.nick
    },
    on: {
      "mouseover": function($event) {
        _vm.ml.hover_nick = _vm.message.nick.toLowerCase();
      },
      "mouseout": function($event) {
        _vm.ml.hover_nick = '';
      }
    }
  }, [_vm._v(_vm._s(_vm.message.nick))]), _vm._v(" "), (_vm.isMessage(_vm.message) && _vm.ml.bufferSetting('show_timestamps')) ? _c('div', {
    staticClass: "kiwi-messagelist-time"
  }, [_vm._v("\n            " + _vm._s(_vm.ml.formatTime(_vm.message.time)) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kiwi-messagelist-body",
    domProps: {
      "innerHTML": _vm._s(_vm.ml.formatMessage(_vm.message))
    }
  }), _vm._v(" "), (_vm.ml.message_info_open === _vm.message) ? _c('message-info', {
    attrs: {
      "message": _vm.message,
      "buffer": _vm.ml.buffer
    },
    on: {
      "close": function($event) {
        _vm.ml.toggleMessageInfo()
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8bfa1ce8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MessageListMessageModern.vue
// module id = 501
// module chunks = 2